if (!customElements.get('wlosale-klaviyo-form')) {
	class KlaviyoForm extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.form = this.querySelector('form');
			this.messages = Array.from(this.form.querySelectorAll('[data-klaviyo-message]'));
			this.listId = this.form.elements.g.value;

			if (!this.listId || !this.form) {
				console.warn(`Klaviyo list ID: ${this.listId}. Form: ${this.form}.`);
				return;
			}

			this.form.addEventListener('submit', this.onSubmit.bind(this));
			const selectElement = this.form.querySelector('select[name="$fields[business]"]');
			selectElement.addEventListener('change', this.updateListId.bind(this));
			document.addEventListener('DOMContentLoaded', this.updateListId.bind(this));
		}

		updateListId() {
			const formElement = document.querySelector('wholesale-klaviyo-form');
			const selectElement = document.querySelector('#business_type');
			const hiddenInput = document.querySelector('input[name="g"]');

			const b2bId = formElement.dataset.b2b;
			const wholesaleId = formElement.dataset.wholesale;

			formElement.setAttribute('data-klaviyo-list-id', b2bId);
			hiddenInput.value = b2bId;

			selectElement.addEventListener('change', function () {
				const selectedValue = selectElement.value;
				const isB2B = ["Manufacturer", "Distributor", "Service Provider", "Retailer", "Other B2B"].includes(selectedValue);
				const newListId = isB2B ? b2bId : wholesaleId;

				hiddenInput.value = newListId;
				this.listId = this.form.elements.g.value;
			});
		}

		onSubmit(event) {
			event.preventDefault();

			const inputFields = Object.keys(this.form.elements).filter(key => key.includes('$fields'));
			const objectData = inputFields.map(item => {
				const name = '$' + item.match(/\w+/g)[1]; //$email
				const value = this.form.elements[item].value;     //lorem@ipsum.com

				return { name, value };
			});
			const fieldsList = objectData.map(item => item.name).join(',');     //$email,$origin,$etc
			const fields = objectData.map(item => ({ [item.name]: item.value })); //{$email: qwe@qwe.ee}

			const defaultData = {
				g: this.form.elements.g.value,
				$fields: fieldsList
			}

			console.log(this.form.elements.g.value);

			const data = Object.assign({}, defaultData, ...fields);   //Merge objects

			if (!this.emailValidate()) return;

			fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
				"method": "POST",
				"mode": "cors",
				"credentials": "omit",
				"X-Requested-With": "XMLHttpRequest",
				"headers": {
					"accept": "*/*",
					"accept-language": "en-US,en;q=0.9",
					"content-type": "application/x-www-form-urlencoded",
				},
				"body": objToStrUrlEncode(data)
			})
				.then(response => response.json())
				.then(response => {
					this.handleMessage(response);
					console.log(response)
				})
				.catch(error => {
					console.log('Klaviyo error:' + error)
				});
		}

		emailValidate() {
			const elements = Array.from(this.form.elements);
			const email = elements.find(input => input.type === 'email');
			const emailValidate = emailValidation(email.value);

			if (!emailValidate) {
				const errorId = `${email.id}--error`;
				const errorMessage = 'Please enter a valid email address.';
				const errorElement = this.getErrorMessage(errorId, errorMessage);

				email.setAttribute('aria-invalid', true);
				email.setAttribute('aria-describedby', errorId);
				email.closest('.field').classList.add('field--with-error');
				email.closest('.field').append(errorElement);
				email.focus();

				setTimeout(() => {
					email.removeAttribute('aria-invalid');
					email.removeAttribute('aria-describedby');
					email.classList.remove('field--with-error');
					errorElement.remove();
				}, 5000);

				return false;
			}

			return true;
		}

		getErrorMessage(id, message) {
			const div = document.createElement('div');
			div.classList.add('form__message');
			div.id = id;
			div.innerHTML = message;

			return div;
		}

		handleMessage(status) {

			if (status.success) {
				if (status.data.is_subscribed) {
					//already subscribe
					const alreadySubElement = this.messages.find(item => item.getAttribute('data-klaviyo-message') === 'already_sub');
					this.showMessage(alreadySubElement);
					// Scroll to the message so it's visible
					setTimeout(() => {
						window.scrollTo({
							top: alreadySubElement.getBoundingClientRect().top + window.pageYOffset - 200,
							behavior: 'smooth'
						});
					}, 100); 
				} else {
					//success
					const successElement = this.messages.find(item => item.getAttribute('data-klaviyo-message') === 'success');
					this.showMessage(successElement);
					// Scroll to the message so it's visible
					setTimeout(() => {
						window.scrollTo({
							top: successElement.getBoundingClientRect().top + window.pageYOffset - 200,
							behavior: 'smooth'
						});
					}, 100); 

					// Clear the form after the message is displayed
					setTimeout(() => {
						this.clearForm();
					}, 5000); // Adjust the timeout as needed
				}
			} else {
				//error
				const errorElement = this.messages.find(item => item.getAttribute('data-klaviyo-message') === 'error');
				this.showMessage(errorElement);
				setTimeout(() => {
					window.scrollTo({
						top: errorElement.getBoundingClientRect().top + window.pageYOffset - 200,
						behavior: 'smooth'
					});
				}, 100); 
			}
		}

		showMessage(element) {
			// Close other messages and show the current one
			this.messages.forEach(msg => msg === element ? msg.removeAttribute('hidden') : msg.hidden = true);
		}

		clearForm() {
			this.form.reset();  // Reset the form fields
			this.messages.forEach(msg => msg.hidden = true);  // Hide all messages
		}
	}

	customElements.define('wholesale-klaviyo-form', KlaviyoForm);
}

function objToStrUrlEncode(obj) {
	const str = [];
	for (var key in obj) {
		if (obj.hasOwnProperty(key) && typeof obj[key] !== 'undefined') {
			str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
		}
	}
	return str.join('&')
}

function emailValidation(email) {
	return email.length > 3 && String(email)
		.toLowerCase()
		.match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
}